import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex grow justify-center w-full font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-center items-center h-full"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col justify-center items-center h-full p-4"
}
const _hoisted_4 = { class: "bg-white border rounded-lg p-8 flex flex-col items-center" }
const _hoisted_5 = { class: "text-xl font-semibold text-gray-800 mb-2" }
const _hoisted_6 = { class: "text-gray-600 text-center" }
const _hoisted_7 = {
  key: 2,
  class: "px-[34px]"
}

import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { 
	IonPage, 
	IonHeader, 
	IonToolbar, 
	IonTitle, 
	IonContent, 
	IonButtons, 
	IonBackButton,
	IonButton,
	IonSpinner,
	IonIcon
} from '@ionic/vue';
import { alertCircleOutline, chevronBackOutline } from 'ionicons/icons';

import BackButton from '@/shared/components/BackButton.vue';
import TopBar from '@/shared/components/TopBar.vue';
import UnsafeHtmlRenderer from '@/shared/components/UnsafeHtmlRenderer.vue';
import NavigationBar from '@/shared/components/ui/NavigationBar.vue';
import usePages from '@/shared/composables/usePages';
import { useSharedStore } from '@/stores/shared/sharedStore';
import { DynamicPage } from '@/shared/interfaces/dynamicPage';
import { useI18n } from 'vue-i18n';

// Route and router

export default /*@__PURE__*/_defineComponent({
  __name: 'ContentPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

// Get page ID from route params
const pageId = computed(() => {
	const id = route.params.id;
	return typeof id === 'string' ? parseInt(id, 10) : null;
});

// Use shared store for pages data
const sharedStore = useSharedStore();
const { pages } = usePages();

const availablePages = computed<DynamicPage[]>(() => {
	if (pages.value && pages.value.length > 0) {
		return pages.value;
	}

	return sharedStore.pages || [];
});

// Computed properties
const page = computed<DynamicPage | undefined>(() => {
	if (!pageId.value) return undefined;
	return availablePages.value.find(p => p.id === pageId.value && p.type === 'html');
});

const isLoading = computed(() => availablePages.value.length === 0);
const error = computed(() => !page.value && availablePages.value.length > 0);

const pageTitle = computed(() => {
	if (isLoading.value) return t('pages.loading');
	if (error.value) return t('pages.error');
	if (page.value) return page.value.title || t('pages.title');
	return t('pages.not_found');
});

const showNavigationBar = computed(() => {
	return page.value?.display_mode === 'content';
});

// Methods
const goBack = () => {
	router.push('/dashboard');
};

const formatDate = (dateString: string): string => {
	try {
		return new Date(dateString).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
	} catch {
		return dateString;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      _createVNode(TopBar, { class: "px-[34px]" }, {
        left: _withCtx(() => [
          _createVNode(BackButton, { to: "/dashboard" })
        ]),
        center: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(pageTitle.value), 1)
        ]),
        right: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
        _: 1
      }),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(IonSpinner), { name: "crescent" })
          ]))
        : (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('pages.not_found')), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('pages.not_found_description')), 1)
              ])
            ]))
          : (page.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(UnsafeHtmlRenderer, {
                  class: "max-w-none",
                  html: typeof page.value.content === 'string' ? page.value.content : '',
                  unsafe: Boolean(page.value.full_html)
                }, null, 8, ["html", "unsafe"])
              ]))
            : _createCommentVNode("", true),
      (showNavigationBar.value)
        ? (_openBlock(), _createBlock(NavigationBar, {
            key: 3,
            "item-active": "pages"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})